import { createSelector } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import { virtualApi } from 'features/api/virtualApiSlice';
import {
  VirtualTemplateAvvenimentoCorse,
  VirtualTemplateAvvenimentoResponseApi,
} from 'lib/api/virtual/virtualTemplateAvvenimentoApi';
import { RootState } from 'lib/centralStore';
import { initialState } from './virtualSlice';

export const _self = (state: RootState) => {
  return state?.virtual ?? initialState;
};

export const selectTs = createSelector([_self], ({ ts }) => ts);
export const selectIsLoading = createSelector([_self], ({ isLoading }) => isLoading ?? false);
export const selectVirtualNav = createSelector([_self], ({ menu }) => menu ?? []);
export const selectSlug = createSelector([_self], ({ slug }) => slug ?? '');

export const selectGetAvvenimentoCorsa = (state: RootState, corsa: string) =>
  virtualApi.endpoints.getVirtualTemplateAvvenimentoCorsa.select(corsa)(state)?.data ??
  ({} as VirtualTemplateAvvenimentoResponseApi & VirtualTemplateAvvenimentoCorse);

export const selectTimeIsGreaterThanTenMinutes = createSelector(
  [_self, (_, dataInizio) => dataInizio],
  (virtual, dataInizio) => {
    const differenceSeconds = (new Date(dataInizio!).getTime() - virtual.currentTime!.getTime()!) / 1000;
    if (differenceSeconds > 600) {
      return {
        timeIsGreaterThanTenMinutes: true,
        hour: format(new Date(dataInizio!), 'kk'),
      };
    }
    return { timeIsGreaterThanTenMinutes: false, hour: '' };
  }
);
